/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetHandoverRequests = (data: any) =>
  useQuery({
    queryKey: [
      "GetHandoverRequests",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
    ],
    queryFn: ({ signal }) =>
      client(`daily/operations/open/handover/requests`, { data, signal }),
  });

export const useCancelHandoverRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (requestId: string) =>
      client(`daily/operations/cancel/handover/request/${requestId}`, {
        successMessage: "Handover request cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetHandoverRequests"] });
    },
  });
};

export const useCreateHandoverRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/handover/request`, {
        data,
        successMessage: "Handover request created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetHandoverRequests"] });
    },
  });
};

export const useGetHandoverJobs = (data: any) =>
  useQuery({
    queryKey: [
      "getHandoverJobs",
      data?.cashCenterId,
      data?.operationDate,
      data?.routeNo,
    ],
    queryFn: ({ signal }) =>
      client(`daily/operations/get/handover/jobs`, { signal, data }),
    enabled:
      Boolean(data?.cashCenterId) &&
      Boolean(data?.operationDate) &&
      Boolean(data?.routeNo),
  });
